// Canonical European Union code lists. Single source of truth shared by the
// server-rendered views and the browser globe client so the lists cannot drift.
// This module is a dependency-free leaf so it is safe to import from the client
// bundle without pulling in the full dataset.

/** All 27 EU member-state ISO 3166-1 alpha-2 codes. */
export const EU_MEMBER_CODES = [
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GR',
  'HR',
  'HU',
  'IE',
  'IT',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
] as const

/**
 * EU member states that have their own national age-assurance policy entries in
 * the dataset. They render as accordion children under the EU entry and as
 * individual flat rows in national filter mode, and are the members outlined on
 * the lifted Mapbox overlay.
 */
export const EU_MEMBER_CODES_IN_DATASET = [
  'AT',
  'BG',
  'CY',
  'DE',
  'DK',
  'ES',
  'FR',
  'GR',
  'IE',
  'IT',
  'MT',
  'NL',
  'PL',
  'PT',
  'SI',
  'SK',
] as const
